export default "__VITE_ASSET__CfAs_USJ__"